import { LiaJava } from "react-icons/lia";
import { LiaReact } from "react-icons/lia";
import { LiaHtml5 } from "react-icons/lia";
import { LiaCss3Alt } from "react-icons/lia";
import { LiaPython } from "react-icons/lia";
import { RiJavascriptFill } from "react-icons/ri";
import { BiLogoTypescript } from "react-icons/bi";

export const codingLanguages = [
  { Icon: LiaJava, alt: "Java", color: "#007396" }, // Java - Blue
  { Icon: LiaReact, alt: "React", color: "#61DAFB" }, // React - Light Blue
  { Icon: LiaHtml5, alt: "HTML5", color: "#E34F26" }, // HTML5 - Orange-Red
  { Icon: LiaCss3Alt, alt: "CSS3", color: "#1572B6" }, // CSS3 - Blue
  { Icon: LiaPython, alt: "Python", color: "#306998" }, // Python - Blue (with some yellow)
  { Icon: RiJavascriptFill, alt: "JavaScript", color: "#F7DF1E" }, // JavaScript - Yellow
  { Icon: BiLogoTypescript, alt: "TypeScript", color: "#3178C6" }, // TypeScript - Blue
];
